import React from 'react';
import { connect } from 'react-redux';
import { List as DictList, mapDispatchToProps } from '../List';
import { REF_NAME, REF_PATH, NAME } from './Const';
import { List as ImmutableList } from 'immutable';
import { UrlWrappedLink, LinkLikeButton } from '@/util/util.jsx';
import { Glyphicon } from 'react-bootstrap';
import { RolesFilter } from '@/component/auth/RolesFilter.jsx';
import trash from '../../../../../style/trash.png';
import pencil from '../../../../../style/pencil.png';
import { hasUserAnyRole } from '@/component/auth/RoleConfigFilter';

class List extends DictList {
  constructor() {
    super();
    this.setRefPath(REF_PATH);
    this.setRefName(REF_NAME);
    this.setName(NAME);
  }


  showAddButton() {
    return hasUserAnyRole(['ROLE_ADMIN']);
  }


  renderModificationButtons(id, ref) {
    return (<div className={'reference-mod-column'}>
      <RolesFilter roles={['ROLE_ADMIN']}>
        <UrlWrappedLink url={`/references/${ref.refPath}/${id}`} id={`edit_${id}`}>
          <img
            src={pencil} alt={'edit'} title={'edit'} className={'payments-table-small-icon'}
          />
        </UrlWrappedLink>
      </RolesFilter>
      {ref.hidden ?
        <RolesFilter roles={['ROLE_ADMIN']}>
          <LinkLikeButton onClick={() => this.restore(id)}>
            <Glyphicon
              title="Restore" id={`restore_${id}`} glyph="repeat"
            />
          </LinkLikeButton>
        </RolesFilter>
        :
        <RolesFilter roles={['ROLE_ADMIN']}>
          <LinkLikeButton onClick={() => { this.openModal(id); }}>
            <img className={'trash-icon'} src={trash} alt={'Delete'} title={'Delete'} />
          </LinkLikeButton>
        </RolesFilter>
      }

    </div>);
  }
}

export default connect((state) =>
  ({ refs: state.getIn(['references', 'simple', REF_PATH], new ImmutableList()) }),
mapDispatchToProps(REF_NAME, REF_PATH))(List);
